
    import Component from "vue-class-component";
    import Vue from "vue";
    import {Prop} from "vue-property-decorator";
    import {
        ApplicationViewModel,
        PersonalInfoRequirementViewModel,
        RequirementFulfillmentStatus,
        RequirementFulfillmentViewModel,
        ApplicationActions
    } from "@/api-client";
    import RequirementProcessingDecision from "@/features/applications/components/RequirementProcessingDecision.vue";
    import PersonalInfoDetails from "@/features/applications/components/requirements/PersonalInfoDetails.vue";
    import {ls} from "@/CultureService";

    @Component({
        components: {PersonalInfoDetails, RequirementProcessingDecision}
    })
    export default class PersonalInfoRequirement extends Vue {
        public static requirementDescriptionTitle = ls.Applications_Requirements_PersonalInfo_Title_PersonalInfoRequirements;

        @Prop({required: true})
        application!: ApplicationViewModel;
        @Prop({required: true})
        requirementFulfillment!: RequirementFulfillmentViewModel;
        @Prop({required: true})
        requirement!: PersonalInfoRequirementViewModel;
        @Prop({required: true})
        actions!: ApplicationActions;

        created(){
            if(this.requirementFulfillment.validationResult.hasMessages()){
                this.$emit("error-happened", this.requirementFulfillment.validationResult);
            }
        }
    }
